export const removeAuthInfoFromStorage = () => {
  localStorage.removeItem("AccessToken");
  localStorage.removeItem("ExpiresIn");
  localStorage.removeItem("RefreshToken");
  localStorage.removeItem("Scope");
  localStorage.removeItem("TokenType");
  localStorage.removeItem("user");
};
